import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "InputProps" })
export default class InputProps extends Vue {
  @Prop({ type: String, default: "" })
  public readonly label!: string;

  @Prop({ type: Boolean, default: false })
  public readonly hideLabel!: string;

  @Prop({ type: String, default: "" })
  public readonly name!: string;

  @Prop({ type: String })
  public readonly hint!: string;

  @Prop({ type: String })
  public readonly value!: string;

  @Prop({ type: String, default: "text" })
  public readonly type!: string;

  @Prop({ type: String })
  public readonly autocomplete!: string;

  @Prop({ type: String })
  public readonly placeholder!: string;

  @Prop({ type: String })
  public readonly pattern!: string;

  @Prop({ type: String })
  public readonly inputmode!: string;

  @Prop({ type: String })
  public readonly maxlength!: string;

  @Prop({ type: String })
  public readonly appendIcon!: string;

  @Prop({ type: [String, Number], default: 22 })
  public readonly appendIconSize!: string;

  @Prop({ type: String })
  public readonly appendIconColor!: string;

  @Prop({ type: String })
  public readonly prependIcon!: string;

  @Prop({ type: [String, Number], default: 22 })
  public readonly prependIconSize!: string;

  @Prop({ type: String })
  public readonly prependIconColor!: string;

  @Prop({ type: [Array, Object, String], default: () => [] })
  public readonly rules!: string[] | Record<string, any> | string;

  @Prop({ type: Object, default: () => ({}) })
  public readonly rulesMessages!: Record<string, string>;

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean;

  @Prop({
    type: String,
    validator: (value: string): boolean =>
      ["aggressive", "passive", "lazy", "eager"].includes(value) || value === undefined,
  })
  public readonly validationMode!: string | undefined;

  @Prop({ type: Boolean, default: false })
  public readonly invalidField!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly hideErrorMessage!: boolean;
}
